module.exports = __webpack_public_path__ + "static/media/trb.f5766a91.png";